import { IconSetCategory } from '../../types';
import { SVGIconDetail } from '../../constants/icons/icons';
import {
  DeliverySatus,
  getDeliveryIconSet,
} from '../../constants/icons/deliveryIcons';
import {
  PaymentInflowStatus,
  getPaymentInflowIconSet,
} from '../../constants/icons/paymentInflow';
import {
  WeatherStatus,
  getWeatherIconSet,
} from '../../constants/icons/weatherIcons';
import {
  PriorityStatus,
  getPriorityIconSet,
} from '../../constants/icons/priorityIcons';
import { RatingStatus, getRatingIconSet } from '../../constants/icons/rating';
import { getNumericObjectValues } from '../../../core/utils/general/general';

// const iconMap: {
//   [category: string]:
//     | ((status: string) => Pick<SVGIconDetail, 'viewBoxSize' | 'paths'>)
//     | undefined;
// } = {
//   [IconSetCategory.Delivery]: getDeliveryIcon,
//   [IconSetCategory.PaymentInflow]: getPaymentInflowIcon,
//   // [IconSetCategory.Priority]: getPriorityIcon,
//   [IconSetCategory.Weather]: getWeatherIcon,
// } as const;

const iconSetMap: {
  [category: string]: (() => SVGIconDetail[]) | undefined;
} = {
  [IconSetCategory.Delivery]: getDeliveryIconSet,
  [IconSetCategory.PaymentInflow]: getPaymentInflowIconSet,
  [IconSetCategory.Priority]: getPriorityIconSet,
  [IconSetCategory.Weather]: getWeatherIconSet,
  [IconSetCategory.Rating]: getRatingIconSet,
} as const;

const iconNamesMap: {
  [category: string]: (() => (string | number)[]) | undefined;
} = {
  [IconSetCategory.Delivery]: () => getNumericObjectValues(DeliverySatus),
  [IconSetCategory.PaymentInflow]: () =>
    getNumericObjectValues(PaymentInflowStatus),
  [IconSetCategory.Priority]: () => getNumericObjectValues(PriorityStatus),
  [IconSetCategory.Weather]: () => getNumericObjectValues(WeatherStatus),
  [IconSetCategory.Rating]: () => getNumericObjectValues(RatingStatus),
} as const;

// export const getIconFromCategory = (category: string, value: string) => {
//   const getIcon = iconMap[category];
//   if (getIcon) {
//     return getIcon(value);
//   }

//   // TODO: Check For User Created Icons
// };

export const getIconSetFromCategory = (category: string) => {
  const getIconSet = iconSetMap[category];
  if (getIconSet) {
    return getIconSet();
  }
};

export const getIconValuesFromCategory = (category: string) => {
  const values = iconNamesMap[category];
  return values ? values() : [];
};
